import React from 'react';
import { PageLayout } from './view/BaseLayout/PageLayout';

const App = () => {
  return (
    <PageLayout
      title="PAGE_PHONE_NUMBERS_TITLE"
      description="PAGE_PHONE_NUMBERS_DESCRIPTION"
    >
      <p>todo: fetch data from api endpoint </p>
    </PageLayout>
  );
};
export default App;
